import { AssetAmmenitiesEs } from 'assets/asset-ammenities/asset-ammenities.es';
import { AssetAmmenitiesPt } from 'assets/asset-ammenities/asset-ammenities.pt';

import { Ammenities } from '@app/entities/ammenities';
import { Languages } from '@app/entities/languages';
import { environment } from '@environment';

export function getAmmenities(language?: string): Ammenities[] {
  const locale = language ?? environment?.language?.toUpperCase();
  if (locale === Languages.Spanish.toUpperCase()) {
    return AssetAmmenitiesEs as Ammenities[];
  } else {
    return AssetAmmenitiesPt as Ammenities[];
  }
}
